// Props and attributes to mixin to Vue components replacing Rails form_for fields
// e.g. %image-field{ model: "company", attribute: "logo" }

export default {
  props: {
    model: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    value: {
      type: String
    }
  },
  computed: {
    inputId() {
      return this.model + '_' + this.attribute
    },
    paramName() {
      if (this.attribute.includes(',')) {
        let attributes = this.attribute.split(',').join('][')

        return this.model + '[' + attributes + ']'
      } else {
        return this.model + '[' + this.attribute + ']'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/mixins/form-options.js